<template>
  <section class="sensualle-info">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="info-content">
            <h2>Sensualle Brazil – Sexy Lingerie from Brazil, Now in Brazil</h2>
            <p>
              At <a href="https://www.lojasensualle.com.br/" target="_blank">Sensualle Brazil</a>, we bring the bold elegance of Brazilian sexy lingerie to Brazil's customers. 
              Indulge in sensuality, comfort, and style in every piece. We specialize in high-quality sensual lingerie, 
              crafted with Brazilian flair to enhance confidence and beauty. Find everything from <strong>panties</strong>, <strong>thongs</strong>, 
              <strong>lingerie sets</strong>, <strong>bodies</strong>, to <strong>men's underwear</strong>—each with its unique appeal.
            </p>

            <h3>Discover Our Brazilian Collections</h3>
            <ul>
              <li><strong><a href="https://www.lojasensualle.com.br/calcinhas/c" target="_blank">Panties (Calcinhas):</a></strong> delicate lace, microfiber, or lycra designs to accentuate your curves with comfort.</li>
              <li><strong><a href="https://www.lojasensualle.com.br/calcinhas/c?estilo=FIO%20DENTAL" target="_blank">Thong (Fio Dental):</a></strong> bold and daring for those wanting an extra edge.</li>
              <li><strong><a href="https://www.lojasensualle.com.br/toda-a-loja/lingerie/c?estilo=CONJUNTO&p=1" target="_blank">Lingerie Sets (Conjuntos):</a></strong> matching bras and panties to elevate your body confidence.</li>
              <li><strong><a href="https://www.lojasensualle.com.br/toda-a-loja/lingerie/c?estilo=BODIES&p=1" target="_blank">Bodies Sexy:</a></strong> sophisticated, modern designs for special occasions.</li>
              <li><strong><a href="https://www.lojasensualle.com.br/category/masculine-underwear" target="_blank">Men's Sexy Underwear (Cuecas):</a></strong> stylish and comfortable options for the modern man.</li>
            </ul>

            <h3>Why Shop at Sensualle Brazil?</h3>
            <ul>
              <li>Local store in <strong>Brazil</strong>, accepting payments in <strong>Brazilian Real (BRL)</strong> with fast, secure shipping nationwide.</li>
              <li>Extensive variety from <strong>everyday basics</strong> to <strong>ultra-sexy pieces</strong> in multiple colors, sizes, and styles.</li>
              <li>Made with premium fabrics like lace, microfiber, and tulle for durability and comfort.</li>
              <li>Brazil-based support for seamless bilingual service and assistance.</li>
            </ul>

            <h3>Sensual Lingerie for Every Occasion</h3>
            <p>
              Sensualle believes every woman deserves to feel sexy and confident every day. Our Brazilian collection 
              features <strong>sensual lingerie</strong>, <strong>sexy panties</strong>, <strong>sets</strong>, and <strong>bodies</strong>, ranging from timeless to daring designs. 
              Whether it's for a romantic evening or daily empowerment—here, you'll find what fits your mood and style.
            </p>

            <h3>Ready to Explore?</h3>
            <p>
              Visit our Brazilian store to shop in BRL and enjoy quick delivery across Brazil. Browse exclusive picks 
              including <strong>panties</strong>, <strong>lingerie</strong>, <strong>bodies</strong>, and more—for comfort, convenience, and a touch of sensuality.
            </p>
            
            <div class="cta-section">
              <a href="https://www.lojasensualle.com.br/" target="_blank" class="btn btn-primary">👉 Shop Sensualle Brazil Now</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SensualleInfo'
}
</script>

<style scoped>
.sensualle-info {
  background-color: #f8f9fa;
  padding: 60px 0;
  margin: 40px 0 0 0;
}

.info-content {
  max-width: 800px;
  margin: 0 auto;
}

.info-content h2 {
  color: var(--primary-color);
  font-size: 2rem;
  margin-bottom: 1.5rem;
  text-align: center;
}

.info-content h3 {
  color: var(--primary-color);
  font-size: 1.5rem;
  margin: 2rem 0 1rem 0;
}

.info-content p {
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  color: #333;
}

.info-content ul {
  margin: 1rem 0 1.5rem 0;
  padding-left: 2rem;
}

.info-content li {
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 0.5rem;
  color: #333;
}

.cta-section {
  text-align: center;
  margin-top: 2rem;
}

.cta-section .btn {
  font-size: 1.2rem;
  padding: 1rem 2rem;
  border-radius: 30px;
  text-decoration: none;
  display: inline-block;
  transition: all 0.3s ease;
}

.cta-section .btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

@media (max-width: 768px) {
  .sensualle-info {
    padding: 40px 0;
  }
  
  .info-content h2 {
    font-size: 1.5rem;
  }
  
  .info-content h3 {
    font-size: 1.3rem;
  }
  
  .info-content p,
  .info-content li {
    font-size: 1rem;
  }
}
</style> 